import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button';

import Api from '../../Api';

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.onSignIn = this.onSignIn.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);

    this.state = {
      error: null
    };
  }

  onSignIn() {
    let redirectQuery = this.props.location.query.redirect
        ? '?redirect=' + this.props.location.query.redirect
        : '';
    return Api.userLogin(this.refs.credential.value)
      .then(
        () => {
          let route = `/user/code/${this.refs.credential.value}${redirectQuery}`;
          this.context.router.push(route);
        },
        error => {
          this.setState({ error });
        }
      );
  }
  
  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.setState({ error: null });
      return this.refs.submit.click(event);
    }
  }

  render() {
    let welcomeback = null;
    if (this.props.location.query.welcomeback) {
      welcomeback = <p className="note">Welcome back! Enter the email or phone number you provided when creating your account to receive your access code.</p>
    }

    let errorMessage = null;
    if (this.state.error && this.state.error.message) {
      errorMessage = <div className="error">{this.state.error.message}</div>;
    }

    return(
      <div className="page-flyout signin">
        <h2>Sign In</h2>
        {welcomeback}
        <div className="input">
          <input type="text" ref="credential" placeholder="Phone or Email" className="center" onKeyPress={this.onKeyPress} />
        </div>
        {errorMessage}
        <div>
          <Button ref="submit" onClick={this.onSignIn}>Request Sign In Code</Button>
        </div>
      </div>
    );
  }
}

SignIn.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/user/signin.js
 **/